


import vue from 'vue'



/// jQuery
window.$ = window.jQuery = require('jquery')
require('jquery-ui/ui/widgets/draggable')
require('jquery-ui/ui/widgets/droppable')
require('jquery-ui/ui/widgets/resizable')
require('jquery-ui/ui/widgets/sortable')
require('imagesloaded')
import transit from 'jquery.transit'



/// Vanilla
var _ = window._ = require('underscore');
var async = window.async = require('async');
var set = window.set = require('set-value')



/// Vue
vue.use(require('vue-touch'))



// WEBPACK FOOTER //
// ./src/app-imports.js